export default __webpack_public_path__ + "static/media/DSC_7547.d4f456bd.jpg";